export default __webpack_public_path__ + "static/media/SB3.21fae765.jpg";